var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.headerTemplate == "ahlia"
      ? _c("div", { staticClass: "print-header" }, [
          _c("header", { staticStyle: { "padding-bottom": "20px" } }, [
            _c(
              "table",
              {
                staticStyle: { width: "100%", "font-size": "18px" },
                style: `direction:${this.sharedLayoutDirection}`,
              },
              [
                _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticStyle: { width: "35%", "text-align": "right" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-bottom": "5px",
                            },
                          },
                          [
                            _vm._v(
                              "\n                 " +
                                _vm._s(
                                  _vm.school && _vm.school.name_ar
                                    ? _vm.school.name_ar
                                    : _vm.Lang.get("messages.site_name_ar")
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "font-size": "15px" } }, [
                          _vm.school && _vm.school.address
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "margin-bottom": "5px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.Lang.get("messages.address")) +
                                      " : " +
                                      _vm._s(_vm.school.address) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.school && _vm.school.phone
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "margin-bottom": "5px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.Lang.get("messages.phone")) +
                                      " : " +
                                      _vm._s(_vm.school.phone)
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.school && _vm.school.fax_number
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "margin-bottom": "5px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.Lang.get("messages.fax")) +
                                      " : " +
                                      _vm._s(_vm.school.fax_number)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm.school
                        ? _c("div", [
                            _c("img", {
                              staticStyle: { height: "150px" },
                              attrs: {
                                src: _vm.school.logo
                                  ? _vm.school.logo
                                  : _vm.headerImg,
                                alt: "school logo",
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { width: "35%", "text-align": "left" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-bottom": "5px",
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.school && _vm.school.name_en
                                    ? _vm.school.name_en
                                    : _vm.Lang.get("messages.site_name_en")
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "font-size": "15px" } }, [
                          _vm.school
                            ? _c("div", [
                                _vm.school.address
                                  ? _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "margin-bottom": "5px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Address : " +
                                            _vm._s(_vm.school.address) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.school.phone
                                  ? _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "margin-bottom": "5px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Phone : " + _vm._s(_vm.school.phone)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.school.fax_number
                                  ? _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "margin-bottom": "5px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Fax : " +
                                            _vm._s(_vm.school.fax_number)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.title
            ? _c(
                "div",
                {
                  staticClass: "body-content",
                  staticStyle: { "font-size": "20px" },
                },
                [
                  _c("div", [
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", { staticStyle: { width: "35%" } }),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "center" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "text-align": "center",
                                display: "inline-block",
                                margin: "10px 0",
                              },
                            },
                            [
                              _vm.title
                                ? _c("p", [
                                    _c("b", [
                                      _vm._v(" " + _vm._s(_vm.title) + " "),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.title && _vm.showDate
                                ? _c("p", [
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm
                                              .moment()
                                              .format("DD/M/YYYY hh:mm")
                                          )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.academic_year
                                ? _c("p", [
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.Lang.get(
                                              "messages.academic_year"
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(_vm.academic_year)
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.fromDate || _vm.toDate
                                ? _c("p", [
                                    _c("b", [
                                      _vm.fromDate
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.Lang.get("messages.from")
                                              ) +
                                                ": " +
                                                _vm._s(_vm.fromDate)
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.toDate
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.Lang.get("messages.to")
                                              ) +
                                                ":" +
                                                _vm._s(
                                                  _vm.toDate ??
                                                    _vm
                                                      .moment()
                                                      .format("DD-MMMM-YYYY")
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", {
                          staticStyle: { width: "35%", "text-align": "center" },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.headerTemplate == "shayee" ? _c("div", [_c("table")]) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }